import React from "react";

import {
    useSpsForm,
    SpsLabel,
    SpsButton,
    SpsValidators,
    SpsTextInput,
    SpsMicroBlock,
} from "@spscommerce/ds-react";
import { ButtonKind, ButtonType, FeedbackBlockKind } from "@spscommerce/ds-shared";
import { SpsPasswordInput } from "../../components/SpsPasswordInput";
import { AppRouteProps } from "../../App";
import { useHistory } from "react-router";
import { useSpsLanguage } from "@spscommerce/i18n";

export function Login({ authService, redirectService }: AppRouteProps) {
    const { t } = useSpsLanguage();
    const [submitted, setSubmitted] = React.useState<boolean>(false);
    const [error, setError] = React.useState<boolean>(false);
    const history = useHistory();
    const { formValue, formMeta } = useSpsForm(
        { password: "", email: "" },
        {
            password: [SpsValidators.required],
            email: [SpsValidators.required, SpsValidators.pattern(/.+@.+\..+/)],
        }
    );

    async function identityLogin(e: any) {
        e.preventDefault();
        setSubmitted(true);
        try {
            const tokenResp = await authService.getToken(formValue.email, formValue.password);
            redirectService.setUserToken(tokenResp.data.access_token);
        } catch (e) {
            console.error(e);
            setError(true);
        }
        setSubmitted(false);
    }

    function validateForm() {
        return (
            formMeta.fields.email.hasError("required") ||
            formMeta.fields.password.hasError("required") ||
            formMeta.fields.email.hasError("pattern")
        );
    }

    function forgotPassword() {
        history.push("/reset-password");
    }
    return (
        <>
            <div className="auth-box">
                <div className="auth-logo">
                    <div className="logo"></div>
                </div>
                <div className="auth-content">
                    <form onSubmit={identityLogin}>
                        <h1 className="auth-content-header">
                            {t("cpauth.login.signInToYourAccount", {
                                defaultValue: "Sign in to your account",
                            })}
                        </h1>
                        <SpsLabel for={formMeta.fields.email}>
                            {t("cpauth.email2", { defaultValue: "Email" })}
                        </SpsLabel>
                        <SpsTextInput
                            className="mb-2"
                            value={formValue.email}
                            formMeta={formMeta.fields.email}
                        />
                        <SpsLabel for={formMeta.fields.password}>
                            {t("cpauth.password", { defaultValue: "Password" })}
                        </SpsLabel>
                        <SpsPasswordInput
                            value={formValue.password}
                            formMeta={formMeta.fields.password}
                            className="mb-2"
                        />
                        {error && (
                            <SpsMicroBlock
                                kind={FeedbackBlockKind.ERROR}
                                message={t("cpauth.login.invalidEmailOrPassword", {
                                    defaultValue: "Invalid email or password.",
                                })}
                            />
                        )}
                        <SpsButton
                            className="mr-1 mb-1 mt-4 auth-button"
                            spinning={submitted}
                            disabled={validateForm()}
                            kind={ButtonKind.CONFIRM}
                            type={ButtonType.SUBMIT}
                        >
                            {t("cpauth.login.signIn", { defaultValue: "Sign In" })}
                        </SpsButton>
                        <SpsButton
                            className="mr-1 mb-1 auth-back-button"
                            kind={ButtonKind.LINK}
                            onClick={forgotPassword}
                        >
                            {t("cpauth.login.forgotpw", { defaultValue: "Forgot Password?" })}
                        </SpsButton>
                    </form>
                </div>
            </div>
        </>
    );
}
